import { isUndefined } from './is';
export function defaults(val) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!isUndefined(val))
        return val;
    if (args.length === 0) {
        return val;
    }
    return defaults.apply(void 0, args);
}
//# sourceMappingURL=defaults.js.map